import { render, staticRenderFns } from "./AddEditImporter.vue?vue&type=template&id=4e81591a"
import script from "./AddEditImporter.vue?vue&type=script&lang=js"
export * from "./AddEditImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports